/**
 * Parse coordinates from various input formats
 * Supports: "36.908, 9.988" or "36.908 9.988"
 *
 * @param {string} input - Coordinates string
 * @returns {object} { lat, lng, isValid, error }
 */
export function parseCoordinates(input) {
  if (!input || typeof input !== 'string') {
    return {
      lat: null,
      lng: null,
      isValid: false,
      error: 'Please enter coordinates'
    };
  }

  // Clean the input - remove extra spaces
  const cleaned = input.trim();

  // Try to parse coordinates (comma or space separated)
  let parts;
  if (cleaned.includes(',')) {
    parts = cleaned.split(',').map(p => p.trim());
  } else {
    parts = cleaned.split(/\s+/);
  }

  // Need exactly 2 parts
  if (parts.length !== 2) {
    return {
      lat: null,
      lng: null,
      isValid: false,
      error: 'Invalid format. Use: 36.908, 9.988'
    };
  }

  // Parse to numbers
  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);

  // Validate numbers
  if (isNaN(lat) || isNaN(lng)) {
    return {
      lat: null,
      lng: null,
      isValid: false,
      error: 'Coordinates must be numbers'
    };
  }

  // Validate ranges
  if (lat < -90 || lat > 90) {
    return {
      lat: null,
      lng: null,
      isValid: false,
      error: 'Latitude must be between -90 and 90'
    };
  }

  if (lng < -180 || lng > 180) {
    return {
      lat: null,
      lng: null,
      isValid: false,
      error: 'Longitude must be between -180 and 180'
    };
  }

  // All good!
  return {
    lat,
    lng,
    isValid: true,
    error: null
  };
}

/**
 * Generate Google Maps URL from coordinates
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {string} Google Maps URL
 */
export function getGoogleMapsUrl(lat, lng) {
  if (!lat || !lng) return null;
  return `https://www.google.com/maps?q=${lat},${lng}`;
}
